export default __webpack_public_path__ + "static/media/screen7.911eb2c3.jpg";